// @ts-nocheck
import { useEffect, useRef, useState, Ref, useMemo, useCallback } from "react";
import { useNavigationStore } from "src/store/navigationStore";

import { Canvas, useFrame, RootState } from "@react-three/fiber";
import { Splat, useGLTF, useAnimations } from "@react-three/drei";
import * as THREE from "three";
import { Group } from "three";

import { GLB_AVATAR } from "src/const/navigationConst";

// import {
//   VenueModelConfig,
//   getVenueModelConfig,
//   getAltitudeByFloorIndex,
//   getFloorNameByFloorIndex,
//   getAltitudeByFloorName,
//   getFloorIndexByFloorName,
// } from "src/const/venue_model/venue_model_config";

import {
  VenueModelConfig,
  getVenueModelConfigByVenueCode,
  getAltitudeByFloorIndex,
  getFloorNameByFloorIndex,
  getAltitudeByFloorName,
  getFloorIndexByFloorName,
  getBaseUrl,
} from "src/utils/map-util";

import { useExplorationStore } from "@/store/explorationStore";

import {
  roundToDecimals,
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  angleDifferenceABtoAC,
  wrapAngle,
} from "src/utils/game";
import * as pc from "playcanvas";
import {
  useTexture,
  useMaterial,
  useEnvAtlas,
  useApp,
  useSplat,
  useModel,
  useAppEvent,
} from "@playcanvas/react/hooks";
import { Application, Entity, Gltf } from "@playcanvas/react";
import {
  Render,
  Camera,
  Light,
  GSplat,
  Script,
  Environment,
} from "@playcanvas/react/components";
import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";

import WatermarkScreen from "src/components/watermark";
import { useLodSplat } from "src/utils/useLodSplat";

let globalFloorList = [];
let globalCurrentFloor = "";

export const webviewGetFloorList = () => {
  console.log("webviewGetFloorList");
  return globalFloorList;
};
export const webviewSetFloor = (floor: number) => {
  console.log("webviewSetFloor" + floor);
  globalCurrentFloor = floor;
};

window["WebViewAPI"] = {
  webviewGetFloorList,
  webviewSetFloor,
};

export default function ExploreFlutter() {
  const setCameraPosition = useExplorationStore(
    (state) => state.setCameraPosition,
  );
  const setCameraLookingPosition = useExplorationStore(
    (state) => state.setCameraLookingPosition,
  );
  const setCameraAngle = useExplorationStore((state) => state.setCameraAngle);

  const setCurrentLevel = useExplorationStore((state) => state.setCurrentLevel);
  const setCurrentLevelIndex = useExplorationStore(
    (state) => state.setCurrentLevelIndex,
  );

  const setExploratingPosition = useExplorationStore(
    (state) => state.setExploratingPosition,
  );
  const setExploratingAngle = useExplorationStore(
    (state) => state.setExploratingAngle,
  );

  const [venueModelConfigState, setVenueModelConfigState] = useState<number>(0);
  const [modelScaleFactorState, setModelScaleFactorState] =
    useState<number>(0.1);
  const moveSpeedRef = useRef<number>(1);
  const rotateSpeedRef = useRef<number>(1);
  const downSpeedRef = useRef<number>(1);

  const topPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const defaultPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const defaultTargetRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));

  const targetAltitudeRef = useRef<number>(0);

  const latestCurrentLevelNameRef = useRef<string>("");
  const isLevelChangingRef = useRef<boolean>(false);

  const mainObjectEntityRef = useRef();
  const cameraScriptRef = useRef();
  const firstPersonCameraEntityRef = useRef();
  const thirdPersonCameraEntityRef = useRef();
  const latestCameraModeRef = useRef<number>(0);

  const transitionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const [modelLoadedState, setModelLoadedState] = useState(false);
  const [coordReadyState, setCoordReadyState] = useState(false);

  const startPosRef = useRef(new pc.Vec3());
  const endPosRef = useRef(new pc.Vec3());

  const [startTransition, setStartTransition] = useState(false);

  const startPos = useRef(new THREE.Vector3());
  const endPos = useRef(new THREE.Vector3());
  const topFloorPosition = useRef(new THREE.Vector3());
  const targetFloorPosition = useRef(new THREE.Vector3());
  const currentFloorRef = useRef("-1");
  const toggleResetRef = useRef(false);

  // const controls = useRef<any>(null);
  // const navigationObject = useRef<Group | null>(null);
  // const firstPersonCameraVector = useRef<Group | null>(null);
  // const thirdPersonCameraVector = useRef<Group | null>(null);

  const isMovingRef = useRef<boolean>(false);
  const isRotatingRef = useRef<boolean>(false);

  const latestPositionJoystickData = useRef<number[]>([0, 0]);
  const latestRotationJoystickData = useRef<number[]>([0, 0]);
  const latestRotationScreenData = useRef<number[]>([0, 0]);

  const latestResetPositionRotationEvent = useRef<number>(0);
  const latestResetOnlyRotationEvent = useRef<number>(0);
  const leaveVenueRef = useRef<number>(0);

  const latestVenueModelConfigRef = useRef<VenueModelConfig | null>(null);

  // const navigationObjectDesiredPosition = useRef<THREE.Vector3>(
  //   new THREE.Vector3(),
  // );
  const initAnimationRef = useRef("init");

  const useQueryParams = () => {
    return useMemo(() => new URLSearchParams(window.location.search), []);
  };

  const DataController = () => {
    const queryParams = useQueryParams();
    let venue = queryParams.get("venue");
    const currentVenue = venue == null || venue == "" ? "xiqu" : venue;

    // const currentVenue = useExplorationStore((state) => state.currentVenue);
    useEffect(() => {
      console.log("init data");

      const venueModelConfig = getVenueModelConfigByVenueCode(currentVenue);
      setVenueModelConfigState(venueModelConfig);

      console.log(venueModelConfig);

      latestVenueModelConfigRef.current = venueModelConfig;
      setModelScaleFactorState(venueModelConfig.scaleFactor);

      moveSpeedRef.current = venueModelConfig.moveSpeed;
      rotateSpeedRef.current = venueModelConfig.rotateSpeed;
      downSpeedRef.current = venueModelConfig.downSpeed;

      const floorNamelist = venueModelConfig.floor.map((f) => f.name);
      globalFloorList = floorNamelist;

      const topFloor = venueModelConfig.floor.reduce((maxFloor, floor) =>
        floor.index > maxFloor.index ? floor : maxFloor,
      );
      const defaultFloor = venueModelConfig.floor.find(
        (floor) => floor.index === venueModelConfig.defaultFloorIndex,
      );
      if (currentLevel == "") {
        setCurrentLevel(defaultFloor?.name ?? floorNamelist[0]);
      }
      topPositionRef.current = new pc.Vec3(
        venueModelConfig.defaultPosition[0] / venueModelConfig.scaleFactor,
        venueModelConfig.topAltitude / venueModelConfig.scaleFactor,
        venueModelConfig.defaultPosition[2] / venueModelConfig.scaleFactor - 1,
      );
      defaultPositionRef.current = new pc.Vec3(
        venueModelConfig.defaultPosition[0] / venueModelConfig.scaleFactor,
        (defaultFloor?.altitude ?? 0) / venueModelConfig.scaleFactor,
        venueModelConfig.defaultPosition[2] / venueModelConfig.scaleFactor,
      );
      defaultTargetRef.current = new pc.Vec3(
        venueModelConfig.defaultPosition[0] / venueModelConfig.scaleFactor,
        (defaultFloor?.altitude ?? 0) / venueModelConfig.scaleFactor,
        venueModelConfig.defaultPosition[2] / venueModelConfig.scaleFactor + 5,
      );
      setCoordReadyState(true);
    }, []);

    const cameraMode = useExplorationStore((state) => state.cameraMode);
    useEffect(() => {
      latestCameraModeRef.current = cameraMode;
    }, [cameraMode]);

    const currentLevel = useExplorationStore((state) => state.currentLevel);
    useEffect(() => {
      const venueModelConfig = getVenueModelConfigByVenueCode(currentVenue);
      latestCurrentLevelNameRef.current = currentLevel;
      const altitude = getAltitudeByFloorName(venueModelConfig, currentLevel);
      targetAltitudeRef.current = altitude / modelScaleFactorState;
      isLevelChangingRef.current = true;
      const levelIndex = getFloorIndexByFloorName(
        venueModelConfig,
        currentLevel,
      );
      setCurrentLevelIndex(levelIndex);
    }, [currentLevel]);

    const resetPositionRotationEvent = useExplorationStore(
      (state) => state.resetPositionRotationEvent,
    );
    useEffect(() => {
      latestResetPositionRotationEvent.current = resetPositionRotationEvent;
    }, [resetPositionRotationEvent]);

    const resetOnlyRotationEvent = useExplorationStore(
      (state) => state.resetOnlyRotationEvent,
    );
    useEffect(() => {
      latestResetOnlyRotationEvent.current = resetOnlyRotationEvent;
    }, [resetOnlyRotationEvent]);

    const leaveVenueEvent = useExplorationStore(
      (state) => state.leaveVenueEvent,
    );
    useEffect(() => {
      leaveVenueRef.current = leaveVenueEvent;
    }, [leaveVenueEvent]);

    const positionJoystickData = useExplorationStore(
      (state) => state.positionJoystickData,
    );
    const rotationJoystickData = useExplorationStore(
      (state) => state.rotationJoystickData,
    );

    useEffect(() => {
      latestPositionJoystickData.current = [
        positionJoystickData[0],
        positionJoystickData[1],
      ];
    }, [positionJoystickData]);

    useEffect(() => {
      latestRotationJoystickData.current = [
        rotationJoystickData[0],
        rotationJoystickData[1],
      ];
    }, [rotationJoystickData]);

    return <></>;
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === " ") {
        e.preventDefault(); // Optional: prevent page scroll
        console.log("!!!!!!!!!! " + globalCurrentFloor);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    console.log("modelLoadedState", modelLoadedState);
    console.log("coordReadyState", coordReadyState);
    if (!coordReadyState || !modelLoadedState) return;

    transitionTimeoutRef.current = setTimeout(() => {
      initAnimationRef.current = "start";
    }, 1000);
  }, [modelLoadedState, coordReadyState]);

  const FloorMeshContainer = () => {
    const [floorMeshUrl, setFloorMeshUrl] = useState<string>("");
    const [floorMeshPosition, setFloorMeshPosition] = useState<pc.Vec3>(
      new pc.Vec3(0, 0, 0),
    );
    useEffect(() => {
      if (latestVenueModelConfigRef.current != null) {
        if (
          latestVenueModelConfigRef.current.floorMesh != null &&
          latestVenueModelConfigRef.current.floorMeshPosition != null
        ) {
          setFloorMeshPosition(
            new pc.Vec3(
              latestVenueModelConfigRef.current.floorMeshPosition[0],
              latestVenueModelConfigRef.current.floorMeshPosition[1],
              latestVenueModelConfigRef.current.floorMeshPosition[2],
            ),
          );
          setFloorMeshUrl(
            latestVenueModelConfigRef.current.baseUrl +
              latestVenueModelConfigRef.current.floorMesh,
          );
        }
      }
    }, []);
    return floorMeshUrl != "" ? (
      <FloorMesh
        floorMeshUrl={floorMeshUrl}
        floorMeshPosition={floorMeshPosition}
      />
    ) : (
      <></>
    );
  };

  const FloorMesh = ({
    floorMeshUrl,
    floorMeshPosition,
  }: {
    floorMeshUrl: string;
    floorMeshPosition: pc.Vec3;
  }) => {
    const floorMeshEntityRef = useRef();
    const { asset: floorMeshAsset } = useModel(floorMeshUrl);

    const changeMaterial = (entity) => {
      if (entity == null) {
        return;
      }
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1.0;
              material.emissive = new pc.Color(1, 1, 1);
              material.useLighting = false;
              material.update();
            }
          });
        }
      });
    };
    useEffect(() => {
      if (floorMeshAsset && floorMeshEntityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(floorMeshEntityRef.current);
        });
      }
    }, [floorMeshAsset]);

    return (
      <Entity
        ref={floorMeshEntityRef}
        rotation={[0, 180, 0]}
        position={[
          floorMeshPosition.x / modelScaleFactorState,
          floorMeshPosition.y / modelScaleFactorState,
          floorMeshPosition.z / modelScaleFactorState,
        ]}
        scale={[
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
        ]}
      >
        <Render type="asset" asset={floorMeshAsset} />
      </Entity>
    );
  };

  const Avatar = () => {
    const app = useApp();
    const avatarEntityRef = useRef();
    let floatTime = 0;
    const _avatarPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
    const { asset: robot } = useModel(GLB_AVATAR);
    const changeMaterial = (entity) => {
      if (entity == null) {
        return;
      }
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1.0;
              material.emissive = new pc.Color(1, 1, 1);
              material.useLighting = false;
              material.update();
            }
          });
        }
      });
    };

    useEffect(() => {
      if (robot && avatarEntityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(avatarEntityRef.current);
        });
      }
    }, [robot]);

    const handleUpdate = useCallback((dt: number) => {
      floatTime += dt;
      if (avatarEntityRef.current) {
        _avatarPositionRef.current.set(0, Math.sin(floatTime * 2) * 0.05, 0);
        avatarEntityRef.current.setLocalPosition(_avatarPositionRef.current);
        avatarEntityRef.current.enabled = latestCameraModeRef.current == 1;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return robot ? (
      <Entity position={[0, -1, 0]}>
        <Entity
          ref={avatarEntityRef}
          rotation={[10, 180, 0]}
          position={[0, 0, 0]}
          scale={[1, 1, 1]}
        >
          <Render type="asset" asset={robot} />
        </Entity>
      </Entity>
    ) : (
      <></>
    );
  };

  const MainCamera = () => {
    const app = useApp();
    let _localProgress;
    let _localCameraMode;
    let isCameraModeUpdated;
    let nearestFixedCameraPosition;

    let finalCameraPosition;
    let finalCameraLookingPosition;

    const handleUpdate = useCallback((dt: number) => {
      if (cameraScriptRef.current == null) {
        return;
      }

      isCameraModeUpdated = _localCameraMode != latestCameraModeRef.current;
      _localCameraMode = latestCameraModeRef.current;

      if (
        initAnimationRef.current != "free" ||
        isCameraModeUpdated ||
        isMovingRef.current ||
        isRotatingRef.current
      ) {
        const newPosition =
          latestCameraModeRef.current == 0
            ? firstPersonCameraEntityRef.current.getPosition()
            : thirdPersonCameraEntityRef.current.getPosition();
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          newPosition,
        );

        isMovingRef.current = false;
        isRotatingRef.current = false;

        setCameraPosition(newPosition);
        setCameraLookingPosition(mainObjectEntityRef.current.getPosition());
        const cameraAngle = getYAngleDegree(
          newPosition,
          mainObjectEntityRef.current.getPosition(),
        );
        setCameraAngle(cameraAngle);
      }
    }, []);
    useAppEvent("update", handleUpdate);

    useEffect(() => {
      const defaultCameraLookingPosition = new pc.Vec3(
        venueModelConfigState.defaultPosition[0] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[1] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[2] / modelScaleFactorState,
      );
      const defaultPosition = new pc.Vec3(
        venueModelConfigState.defaultPosition[0] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[1] / modelScaleFactorState,
        venueModelConfigState.defaultPosition[2] / modelScaleFactorState - 1,
      );
      //mainObjectEntityRef.current.setPosition(defaultPosition);
      cameraScriptRef.current.reset(
        defaultCameraLookingPosition,
        defaultPosition,
      );
    }, []);

    return (
      <Entity>
        <Camera />
        <Script
          ref={cameraScriptRef}
          script={CameraControls}
          enableFly={false}
        />
      </Entity>
    );
  };

  const MainObject = () => {
    const app = useApp();

    let goDownAnimationTime = 0;
    const goDownDuration = 3;

    let goUpAnimationTime = 0;
    const goUpDuration = 2;

    const eulerRef = useRef(new pc.Vec3(0, 180, 0));
    let _localResetPositionRotationEvent = 0;
    let _localResetOnlyRotationEvent = 0;
    let _localLeaveVenueEvent = 0;
    let temp = false;

    useEffect(() => {
      mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
    }, []);

    const handleUpdate = useCallback((dt: number) => {
      if (mainObjectEntityRef.current == null) {
        return;
      }

      let isResetPositionRotation =
        _localResetPositionRotationEvent !=
        latestResetPositionRotationEvent.current;
      _localResetPositionRotationEvent =
        latestResetPositionRotationEvent.current;

      let isResetOnlyRotation =
        _localResetOnlyRotationEvent != latestResetOnlyRotationEvent.current;
      _localResetOnlyRotationEvent = latestResetOnlyRotationEvent.current;

      let isLeaveVenue = _localLeaveVenueEvent != leaveVenueRef.current;
      _localLeaveVenueEvent = leaveVenueRef.current;

      if (initAnimationRef.current == "init") {
        mainObjectEntityRef.current.setPosition(topPositionRef.current);
        mainObjectEntityRef.current.lookAt(defaultPositionRef.current);
      } else if (initAnimationRef.current == "start") {
        if (goDownAnimationTime >= goDownDuration) {
          mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
          mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
          initAnimationRef.current = "free";
          return;
        }
        goDownAnimationTime += dt;
        const t = Math.min(goDownAnimationTime / goDownDuration, 1);
        const newPos = new pc.Vec3().lerp(
          topPositionRef.current,
          defaultPositionRef.current,
          t,
        );
        mainObjectEntityRef.current.setPosition(newPos);
        const lookTarget = new pc.Vec3().lerp(
          defaultPositionRef.current,
          defaultTargetRef.current,
          t,
        );
        mainObjectEntityRef.current.lookAt(lookTarget); // now safe, position is already set
      } else if (initAnimationRef.current == "free") {
        if (latestPositionJoystickData.current.length != 2) {
          return;
        }

        if (isLevelChangingRef.current) {
          isMovingRef.current = true;
          const targetPosition = new pc.Vec3(
            mainObjectEntityRef.current.getPosition().x,
            targetAltitudeRef.current,
            mainObjectEntityRef.current.getPosition().z,
          );
          const distance = vec3Distance(
            mainObjectEntityRef.current.getPosition(),
            targetPosition,
          );
          const positionAlpha = Math.min(1, (3 * dt) / distance);
          mainObjectEntityRef.current.setPosition(targetPosition);
          isLevelChangingRef.current = false;
        }

        if (
          latestPositionJoystickData.current[0] != 0 ||
          latestPositionJoystickData.current[1] != 0
        ) {
          isMovingRef.current = true;
          const worldMat = mainObjectEntityRef.current.getWorldTransform();
          const forward = new pc.Vec3(0, 0, -1);
          worldMat.transformVector(forward, forward);
          forward.y = 0;
          forward.normalize();
          const up = pc.Vec3.UP.clone();
          const right = new pc.Vec3();
          right.cross(up, forward).normalize();
          const forwardScale =
            latestPositionJoystickData.current[1] * moveSpeedRef.current * -dt;
          const rightScale =
            latestPositionJoystickData.current[0] * moveSpeedRef.current * -dt;
          const forwardMove = forward.clone().mulScalar(forwardScale);
          const rightMove = right.clone().mulScalar(rightScale);
          const move = new pc.Vec3();
          move.add(forwardMove).add(rightMove);
          mainObjectEntityRef.current.translate(move);
        }

        if (
          latestRotationJoystickData.current[0] != 0 ||
          latestRotationJoystickData.current[1] != 0
        ) {
          isRotatingRef.current = true;

          eulerRef.current.y +=
            -latestRotationJoystickData.current[0] *
            rotateSpeedRef.current *
            dt; // Yaw
          eulerRef.current.x +=
            -latestRotationJoystickData.current[1] *
            rotateSpeedRef.current *
            dt; // Pitch

          eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
          eulerRef.current.y = wrapAngle(eulerRef.current.y);

          mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
        }

        if (
          latestRotationScreenData.current[0] != 0 ||
          latestRotationScreenData.current[1] != 0
        ) {
          isRotatingRef.current = true;

          eulerRef.current.y +=
            -latestRotationScreenData.current[0] * rotateSpeedRef.current * dt; // Yaw
          eulerRef.current.x +=
            -latestRotationScreenData.current[1] * rotateSpeedRef.current * dt; // Pitch

          eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
          eulerRef.current.y = wrapAngle(eulerRef.current.y);

          mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
        }

        // handle reset
        if (isResetPositionRotation) {
          isMovingRef.current = true;
          isRotatingRef.current = true;
          mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
          mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
        }
        if (isResetOnlyRotation) {
          isRotatingRef.current = true;
          eulerRef.current.x = 0;
          mainObjectEntityRef.current.setLocalEulerAngles(
            eulerRef.current.x,
            eulerRef.current.y,
            eulerRef.current.z,
          );
        }
        if (isLeaveVenue) {
          mainObjectEntityRef.current.setPosition(defaultPositionRef.current);
          mainObjectEntityRef.current.lookAt(defaultTargetRef.current);
          initAnimationRef.current = "ending";
        }
      } else if (initAnimationRef.current == "ending") {
        console.log("ending");
        if (goUpAnimationTime >= goUpDuration) {
          mainObjectEntityRef.current.setPosition(topPositionRef.current);
          mainObjectEntityRef.current.lookAt(defaultPositionRef.current);
          return;
        }
        goUpAnimationTime += dt;
        const t = Math.min(goUpAnimationTime / goUpDuration, 1);
        const newPos = new pc.Vec3().lerp(
          defaultPositionRef.current,
          topPositionRef.current,
          t,
        );
        mainObjectEntityRef.current.setPosition(newPos);
        const lookTarget = new pc.Vec3().lerp(
          defaultTargetRef.current,
          defaultPositionRef.current,
          t,
        );
        mainObjectEntityRef.current.lookAt(lookTarget); // now safe, position is already set
      }
    }, []);
    useAppEvent("update", handleUpdate);

    return (
      <Entity ref={mainObjectEntityRef}>
        <Avatar />
        <Entity
          ref={firstPersonCameraEntityRef}
          position={[0, 0, 0.5]}
        ></Entity>
        <Entity
          ref={thirdPersonCameraEntityRef}
          position={[0, 0.5, 4]}
        ></Entity>
      </Entity>
    );
  };

  const VenueLod = () => {
    const baseUrl = getBaseUrl();
    const setLoading = useNavigationStore((state) => state.setLoading);
    const app = useApp();
    const gsplatRef = useRef();
    const { asset, loading, error, lodDistances } = useLodSplat(
      // venueModelConfigState!.baseUrl + venueModelConfigState!.lod,
      baseUrl + venueModelConfigState!.folderPath + venueModelConfigState!.lod,
    );

    useEffect(() => {
      if (!asset) {
        return;
      }
      const gsplatEntity = gsplatRef.current;
      if (!gsplatRef.current || !app) return;
      gsplatRef.current.gsplat.enabled = true;
      gsplatRef.current.gsplat.unified = true;
      gsplatRef.current.gsplat.asset = asset;
      gsplatRef.current.gsplat.lodDistances = [
        20 * modelScaleFactorState,
        100 * modelScaleFactorState,
        500 * modelScaleFactorState,
      ];
      gsplatRef.current.gsplat.enabled = true;
      //app.scene.gsplat.colorizeLod = true;
      setModelLoadedState(true);
      setLoading(false);
    }, [asset]);

    return (
      <Entity
        ref={gsplatRef}
        rotation={[180, 0, 0]}
        position={[0, 0, 0]}
        scale={[
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
          1 / modelScaleFactorState,
        ]}
      >
        <GSplat />
      </Entity>
    );
  };

  const WebviewDataController = () => {
    const handleUpdate = useCallback((dt: number) => {
      if (
        globalCurrentFloor != "" &&
        latestCurrentLevelNameRef.current != globalCurrentFloor
      ) {
        setCurrentLevel(globalCurrentFloor);
      }
    }, []);
    useAppEvent("update", handleUpdate);
    return <></>;
  };

  const PlaycanvasScene = () => {
    const app = useApp();
    return (
      <>
        {venueModelConfigState!.lod ? <VenueLod /> : <></>}
        <FloorMeshContainer />
        <MainObject />
        <MainCamera />
        <WebviewDataController />
      </>
    );
  };

  const Scene = () => {
    return (
      <Application>
        {venueModelConfigState != null && modelScaleFactorState > 0 ? (
          <PlaycanvasScene />
        ) : (
          <></>
        )}
      </Application>
    );
  };

  console.log(
    "ExplorationPage component rendered , if this keep showing, something wrong",
  );

  const DragController = () => {
    const isDraggingRef = useRef(false);
    const startPosRef = useRef({ x: 0, y: 0 });
    const previousPositionRef = useRef({ x: 0, y: 0 });
    const getClientPos = (e) => {
      if (e.touches && e.touches.length > 0) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    };
    const handleStart = useCallback((e) => {
      const pos = getClientPos(e);
      isDraggingRef.current = true;
      previousPositionRef.current = { x: pos.x, y: pos.y };
    }, []);
    const handleMove = useCallback((e) => {
      if (!isDraggingRef.current) {
        return;
      }
      const pos = getClientPos(e);
      const xChange = pos.x - previousPositionRef.current.x;
      const yChange = pos.y - previousPositionRef.current.y;
      previousPositionRef.current = { x: pos.x, y: pos.y };
      latestRotationScreenData.current[0] = xChange * 0.5;
      latestRotationScreenData.current[1] = yChange * 0.5;
    }, []);
    const handleEnd = useCallback(() => {
      isDraggingRef.current = false;
      latestRotationScreenData.current[0] = 0;
      latestRotationScreenData.current[1] = 0;
    }, []);
    useEffect(() => {
      window.addEventListener("mouseup", handleEnd);
      window.addEventListener("touchend", handleEnd);
      return () => {
        window.removeEventListener("mouseup", handleEnd);
        window.removeEventListener("touchend", handleEnd);
      };
    }, []);

    return (
      <div
        className="fullscreen_div"
        onMouseDown={handleStart}
        onTouchStart={handleStart}
        onMouseMove={handleMove}
        onTouchMove={handleMove}
        onMouseUp={handleEnd}
        onTouchEnd={handleEnd}
      ></div>
    );
  };

  return (
    <div
      className="absolute top-0 left-0 w-full h-full"
      style={{ backgroundColor: "black" }}
    >
      <DataController />
      <Scene />
      <DragController />
      <WatermarkScreen />
    </div>
  );
}
